/**
 * Events page: Blog URL + Attentive URL from the Events sheet.
 * RSVP ("Let us know you're coming") opens that event's Attentive embed
 * in a popup so the shopper never leaves the page. Dallas vs McAllen is
 * whichever Attentive URL is on that row.
 */
(function () {
  var DEFAULT_CSV =
    "https://docs.google.com/spreadsheets/d/e/2PACX-1vTXET-wwCXX7tzCK148emc0FsD9oMNSxLNTkAInL_rRWqIL8FOpWlYtxQC-Djc5BjLOXgHTtfa3N1B7/pub?output=csv&gid=0";

  var FALLBACK_BY_TITLE = {
    "dallas fall ring pop up": {
      blogUrl:
        "https://www.sanjosewaco.com/blogs/jewelry-talk/dallas-back-to-school-ring-pop-up-design-studio-8-15-2026",
    },
  };

  var BLOG_KEYS = ["blog_url", "blog", "event_details_url", "article_url"];
  var ATTN_KEYS = [
    "attentive_url",
    "attentive",
    "signup_url",
    "landing_page",
    "attn_url",
    "attentive_landing_page",
  ];
  var HIDE_DATE_KEYS = [
    "hide_box",
    "hide_date",
    "high_date",
    "hide_dates",
    "hide_date_badge",
    "hide_badge",
  ];

  var state = {
    rows: [],
    byTitle: {},
    ready: false,
  };

  function cfg() {
    return window.SJ_EVENTS_EMBED || {};
  }

  function slugHeader(raw) {
    return String(raw || "")
      .replace(/[\r\n]+/g, " ")
      .toLowerCase()
      .trim()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9\s-]/g, " ")
      .trim()
      .replace(/[\s-]+/g, "_");
  }

  function normTitle(s) {
    return String(s || "")
      .toLowerCase()
      .replace(/\s+/g, " ")
      .trim();
  }

  function pick(row, keys) {
    for (var i = 0; i < keys.length; i++) {
      var v = row[keys[i]];
      if (v) return String(v).trim();
    }
    return "";
  }

  function isYes(v) {
    v = String(v || "")
      .trim()
      .toLowerCase()
      .replace(/[.,!]/g, "");
    return v === "yes" || v === "y" || v === "true" || v === "1";
  }

  function parseSheetDate(s) {
    var m = String(s || "")
      .trim()
      .match(/^(\d{1,2})\/(\d{1,2})\/(\d{2,4})/);
    if (!m) return null;
    var y = parseInt(m[3], 10);
    if (y < 100) y += 2000;
    return new Date(y, parseInt(m[1], 10) - 1, parseInt(m[2], 10));
  }

  function daySpan(first, last) {
    if (!first || !last) return 0;
    return Math.round((last - first) / 86400000);
  }

  function rangeNeedsThrough(dates) {
    var parsed = (dates || []).map(parseSheetDate).filter(Boolean);
    if (parsed.length < 2) return false;
    return daySpan(parsed[0], parsed[parsed.length - 1]) > 1;
  }

  function insertThroughLabel(card, row) {
    var datesEl = card.querySelector(".event-item__dates");
    if (!datesEl) return;
    var existing = datesEl.querySelector(".sj-date-through");
    var needs = row && row.needsThrough;
    if (!needs) {
      var times = datesEl.querySelectorAll("time[datetime]");
      if (times.length >= 2) {
        var first = new Date(times[0].getAttribute("datetime"));
        var last = new Date(times[times.length - 1].getAttribute("datetime"));
        if (!isNaN(first.getTime()) && !isNaN(last.getTime())) {
          var a = new Date(first.getFullYear(), first.getMonth(), first.getDate());
          var b = new Date(last.getFullYear(), last.getMonth(), last.getDate());
          needs = daySpan(a, b) > 1;
        }
      }
    }
    if (!needs) {
      if (existing) existing.remove();
      return;
    }
    if (existing) return;
    var grid = datesEl.querySelector(".grid") || datesEl;
    var timeEls = grid.querySelectorAll("time");
    if (timeEls.length < 2) return;
    var second = timeEls[1].closest("span") || timeEls[1];
    var through = document.createElement("div");
    through.className = "sj-date-through";
    through.textContent = "through";
    second.parentNode.insertBefore(through, second);
  }

  function looksLikeUrl(s) {
    return /^https?:\/\//i.test(String(s || "").trim());
  }

  function addVenuePart(parts, raw) {
    String(raw || "")
      .split("|")
      .forEach(function (piece) {
        piece = piece.trim().replace(/\s+/g, " ");
        if (!piece) return;
        var lower = piece.toLowerCase();
        for (var i = 0; i < parts.length; i++) {
          var existing = parts[i].toLowerCase();
          if (existing === lower) return;
          if (existing.indexOf(lower) !== -1) return;
          if (lower.indexOf(existing) !== -1) {
            parts[i] = piece;
            return;
          }
        }
        parts.push(piece);
      });
  }

  function venueLine(row) {
    var parts = [];
    addVenuePart(parts, row.locationName);
    addVenuePart(parts, row.locationAddress);
    addVenuePart(parts, row.locationCity);
    return parts.join(", ");
  }

  function mapsSearchUrl(row) {
    var parts = [];
    addVenuePart(parts, row.locationName);
    addVenuePart(parts, row.locationAddress);
    addVenuePart(parts, row.locationCity);
    addVenuePart(parts, row.locationZip);
    if (!parts.length) return "";
    var query = encodeURIComponent(parts.join(", "));
    if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
      return "https://maps.apple.com/?q=" + query;
    }
    return "https://www.google.com/maps/search/?api=1&query=" + query;
  }

  function parseCsv(text) {
    var rows = [];
    var row = [];
    var cell = "";
    var inQuotes = false;
    for (var i = 0; i < text.length; i++) {
      var c = text[i];
      var next = text[i + 1];
      if (inQuotes) {
        if (c === '"' && next === '"') {
          cell += '"';
          i++;
        } else if (c === '"') {
          inQuotes = false;
        } else {
          cell += c;
        }
      } else if (c === '"') {
        inQuotes = true;
      } else if (c === ",") {
        row.push(cell);
        cell = "";
      } else if (c === "\n") {
        if (cell.charAt(cell.length - 1) === "\r") cell = cell.slice(0, -1);
        row.push(cell);
        rows.push(row);
        row = [];
        cell = "";
      } else {
        cell += c;
      }
    }
    if (cell.length || row.length) {
      row.push(cell);
      rows.push(row);
    }
    return rows;
  }

  function rowsToEvents(grid) {
    if (!grid.length) return [];
    var headers = grid[0].map(slugHeader);
    var out = [];
    for (var r = 1; r < grid.length; r++) {
      var line = grid[r];
      if (!line || !line.join("").trim()) continue;
      var obj = {};
      for (var c = 0; c < headers.length; c++) {
        if (headers[c]) obj[headers[c]] = (line[c] || "").trim();
      }
      var title = obj.title || "";
      if (!title) continue;
      var fallback = FALLBACK_BY_TITLE[normTitle(title)] || {};
      out.push({
        title: title,
        key: normTitle(title),
        blogUrl: pick(obj, BLOG_KEYS) || fallback.blogUrl || "",
        attentiveUrl: pick(obj, ATTN_KEYS) || fallback.attentiveUrl || "",
        attentiveId: (obj.attentive_id || obj.creative_id || "").trim(),
        locationName: obj.location_name || "",
        locationAddress: obj.location_address || "",
        locationCity: obj.location_city || "",
        locationZip: obj.location_zip || "",
        hideDate: isYes(pick(obj, HIDE_DATE_KEYS)),
        date1: obj.date_day_1 || "",
        date2: obj.date_day_2 || "",
        date3: obj.date_day_3 || "",
        needsThrough: rangeNeedsThrough([
          obj.date_day_1,
          obj.date_day_2,
          obj.date_day_3,
        ]),
      });
    }
    return out;
  }

  function indexRows(rows) {
    var map = {};
    rows.forEach(function (row) {
      var prev = map[row.key];
      if (prev) {
        if (row.needsThrough) prev.needsThrough = true;
        if (row.blogUrl) prev.blogUrl = row.blogUrl;
        if (row.attentiveUrl) prev.attentiveUrl = row.attentiveUrl;
        if (row.attentiveId) prev.attentiveId = row.attentiveId;
        return;
      }
      map[row.key] = row;
    });
    state.rows = rows;
    state.byTitle = map;
  }

  function matchCard(card) {
    var names = card.querySelectorAll(".event-item__name");
    for (var i = 0; i < names.length; i++) {
      var key = normTitle(names[i].textContent);
      if (key && state.byTitle[key]) return state.byTitle[key];
    }
    var attr = card.getAttribute("data-sj-event-title") || "";
    if (attr && state.byTitle[normTitle(attr)]) return state.byTitle[normTitle(attr)];
    return null;
  }

  function matchArticle() {
    var path = (location.pathname || "").replace(/\/+$/, "");
    if (!path) return null;
    for (var i = 0; i < state.rows.length; i++) {
      var row = state.rows[i];
      if (!row.blogUrl) continue;
      try {
        var u = new URL(row.blogUrl, location.origin);
        var p = u.pathname.replace(/\/+$/, "");
        if (p === path) return row;
      } catch (e) {
        if (row.blogUrl.indexOf(path) !== -1) return row;
      }
    }
    return null;
  }

  function ensureModal() {
    var el = document.getElementById("sj-attn-modal");
    if (el) return el;
    el = document.createElement("div");
    el.id = "sj-attn-modal";
    el.className = "sj-attn-modal";
    el.setAttribute("hidden", "");
    el.innerHTML =
      '<div class="sj-attn-modal__backdrop" data-sj-attn-close="1"></div>' +
      '<div class="sj-attn-modal__panel" role="dialog" aria-modal="true" aria-labelledby="sj-attn-modal-title">' +
      '<button type="button" class="sj-attn-modal__close" data-sj-attn-close="1" aria-label="Close">&times;</button>' +
      '<h3 id="sj-attn-modal-title" class="sj-attn-modal__heading ff-heading">RSVP</h3>' +
      '<p class="sj-attn-modal__event fs-body-75"></p>' +
      '<iframe class="sj-attn-modal__frame" title="Event signup" loading="lazy"></iframe>' +
      "</div>";
    document.body.appendChild(el);
    el.addEventListener("click", function (e) {
      if (e.target && e.target.getAttribute("data-sj-attn-close")) closeModal();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !el.hasAttribute("hidden")) closeModal();
    });
    return el;
  }

  function closeModal() {
    var el = document.getElementById("sj-attn-modal");
    if (!el) return;
    el.setAttribute("hidden", "");
    document.body.classList.remove("sj-attn-modal-open");
    var frame = el.querySelector("iframe");
    if (frame) frame.src = "about:blank";
  }

  function openAttentive(row) {
    var url = row.attentiveUrl;
    var id = row.attentiveId;
    if (!url && id && window.__attentive && typeof window.__attentive.trigger === "function") {
      window.__attentive.trigger(null, null, null, id);
      return;
    }
    if (!url) return;
    if (!looksLikeUrl(url) && window.__attentive && typeof window.__attentive.trigger === "function") {
      window.__attentive.trigger(null, null, null, url);
      return;
    }
    var modal = ensureModal();
    modal.querySelector(".sj-attn-modal__event").textContent = row.title || "";
    var frame = modal.querySelector("iframe");
    frame.src = url;
    modal.removeAttribute("hidden");
    document.body.classList.add("sj-attn-modal-open");
  }

  function enhanceCard(card) {
    var row = matchCard(card);
    if (!row) return;

    card.setAttribute("data-sj-event-title", row.title);

    var rsvp = card.querySelector(".event-item__callout");
    if (rsvp) {
      rsvp.classList.add("sj-event-signup-btn");
      rsvp.classList.remove("btn--callout");
    }

    if (row.hideDate) {
      card.setAttribute("data-sj-hide-date", "1");
      card.classList.add("sj-hide-date-badge");
      card.querySelectorAll(".event-item__date-badge").forEach(function (badge) {
        badge.setAttribute("hidden", "");
        badge.setAttribute("aria-hidden", "true");
        badge.style.setProperty("display", "none", "important");
      });
    } else {
      card.removeAttribute("data-sj-hide-date");
      card.classList.remove("sj-hide-date-badge");
    }

    var mapUrl = mapsSearchUrl(row);
    var line = venueLine(row);
    var venues = card.querySelectorAll(".event-item__venue");
    if (venues.length && line) {
      var venueEl = venues[0];
      var mapLink = venueEl.querySelector(".sj-event-map-link");
      if (!mapLink) {
        mapLink = document.createElement("a");
        mapLink.className = "sj-event-map-link";
        mapLink.target = "_blank";
        mapLink.rel = "noopener noreferrer";
        venueEl.textContent = "";
        venueEl.appendChild(mapLink);
      }
      mapLink.href = mapUrl || mapLink.href;
      mapLink.textContent = line;
      for (var v = 1; v < venues.length; v++) {
        venues[v].classList.add("sj-venue-hidden");
      }
    }

    insertThroughLabel(card, row);

    if (row.blogUrl && !card.querySelector(".sj-event-details-link")) {
      var details = card.querySelector(".event-item__details");
      var link = document.createElement("a");
      link.className = "sj-event-details-link";
      link.href = row.blogUrl;
      link.textContent = "Event details";
      if (details && rsvp) details.insertBefore(link, rsvp);
      else if (details) details.appendChild(link);

      var imgWrap = card.querySelector(".event-item__image-wrapper");
      if (imgWrap && !imgWrap.dataset.sjBlogBound) {
        imgWrap.dataset.sjBlogBound = "1";
        imgWrap.classList.add("sj-event-image-link");
        imgWrap.addEventListener("click", function (e) {
          if (e.target.closest(".event-item__callout")) return;
          location.href = row.blogUrl;
        });
      }

      var nameEl = card.querySelector(".event-item__name");
      if (nameEl && !nameEl.dataset.sjBlogBound) {
        nameEl.dataset.sjBlogBound = "1";
        nameEl.classList.add("sj-event-name-link");
        nameEl.addEventListener("click", function () {
          location.href = row.blogUrl;
        });
      }
    }

    if (row.attentiveUrl || row.attentiveId) {
      card.setAttribute("data-sj-has-attentive", "true");
    }
  }

  function enhanceAllCards(root) {
    (root || document).querySelectorAll(".event-item").forEach(function (card) {
      var rsvp = card.querySelector(".event-item__callout");
      if (rsvp) {
        rsvp.classList.add("sj-event-signup-btn");
        rsvp.classList.remove("btn--callout");
        var label = rsvp.querySelector("span");
        if (label) label.textContent = "RSVP";
      }
      enhanceCard(card);
    });
  }

  function bindRsvpCapture(widget) {
    if (widget.dataset.sjAttnBound) return;
    widget.dataset.sjAttnBound = "1";
    widget.addEventListener(
      "click",
      function (e) {
        var btn = e.target.closest(".event-item__callout");
        if (!btn) return;
        var card = btn.closest(".event-item");
        if (!card) return;
        var row = matchCard(card);
        if (!row || !(row.attentiveUrl || row.attentiveId)) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        openAttentive(row);
      },
      true
    );
  }

  function watchWidget(widget) {
    if (widget.dataset.sjWatchBound) return;
    widget.dataset.sjWatchBound = "1";
    bindRsvpCapture(widget);
    enhanceAllCards(widget);
    var scheduled = false;
    var obs = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        enhanceAllCards(widget);
      });
    });
    obs.observe(widget, { childList: true, subtree: true });
    [80, 400].forEach(function (ms) {
      setTimeout(function () {
        enhanceAllCards(widget);
      }, ms);
    });
  }

  function csvCacheKey(url) {
    return "sj-events-csv:" + url;
  }

  function readCsvCache(url) {
    try {
      var raw = sessionStorage.getItem(csvCacheKey(url));
      if (!raw) return "";
      var parsed = JSON.parse(raw);
      if (!parsed || parsed.url !== url || !parsed.text) return "";
      if (Date.now() - parsed.at > 5 * 60 * 1000) return "";
      return parsed.text;
    } catch (e) {
      return "";
    }
  }

  function writeCsvCache(url, text) {
    try {
      sessionStorage.setItem(
        csvCacheKey(url),
        JSON.stringify({ url: url, text: text, at: Date.now() })
      );
    } catch (e) {}
  }

  function loadCsv(url) {
    var cached = readCsvCache(url);
    if (cached) return Promise.resolve(cached);
    var pending = window.__sjEventsCsv;
    var req = pending
      ? pending.catch(function () {
          return fetch(url, { credentials: "omit" }).then(function (res) {
            if (!res.ok) throw new Error("events csv " + res.status);
            return res.text();
          });
        })
      : fetch(url, { credentials: "omit" }).then(function (res) {
          if (!res.ok) throw new Error("events csv " + res.status);
          return res.text();
        });
    return req.then(function (text) {
      writeCsvCache(url, text);
      return text;
    });
  }

  function applyCsv(text) {
    indexRows(rowsToEvents(parseCsv(text)));
    state.ready = true;
    document.querySelectorAll("x-events-widget").forEach(watchWidget);
    var articleRow = matchArticle();
    if (articleRow) injectArticleCta(articleRow);
  }

  function start() {
    var csvUrl = cfg().csvUrl || "";
    var widget = document.querySelector("x-events-widget");
    if (!csvUrl && widget) csvUrl = widget.getAttribute("gsheet-get-url") || "";
    if (!csvUrl) csvUrl = DEFAULT_CSV;

    loadCsv(csvUrl)
      .then(applyCsv)
      .catch(function (err) {
        console.warn("sj-events-embed", err);
      });
  }

  function injectArticleCta(row) {
    if (!(row.attentiveUrl || row.attentiveId)) return;
    if (document.querySelector(".sj-article-event-cta")) return;
    var article =
      document.querySelector(".article__content") ||
      document.querySelector(".article .rte") ||
      document.querySelector("article");
    if (!article) return;
    var wrap = document.createElement("div");
    wrap.className = "sj-article-event-cta";
    wrap.innerHTML =
      '<p class="sj-article-event-cta__label fs-body-75">Going to this event?</p>' +
      '<button type="button" class="btn btn--callout sj-article-event-cta__btn">RSVP</button>';
    wrap.querySelector("button").addEventListener("click", function () {
      openAttentive(row);
    });
    article.appendChild(wrap);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
